import React from 'react';
import classNames from 'classnames';
import { useIntl } from '../../../../util/reactIntl';
import flowchartEn from '../../../../assets/images/merchant-flowchart-en.png';
import flowchartAr from '../../../../assets/images/merchant-flowchart-ar.png';
import css from './GoLiveSteps.module.css';

const GoLiveSteps = () => {
  const intl = useIntl();
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  return (
    <section className={classNames(css.section, arabicLanguage && css.arabicDirection)}>
      <div className={css.inner}>
        <div className={css.header}>
          <h2 className={css.title}>{intl.formatMessage({ id: 'ForBusiness.stepsTitle' })}</h2>
          {/* <p className={css.subtitle}>{intl.formatMessage({ id: 'ForBusiness.stepsSub' })}</p> */}
        </div>

        <div className={css.flowImageWrap}>
          <img
            src={arabicLanguage ? flowchartAr : flowchartEn}
            alt={intl.formatMessage({ id: 'ForBusiness.stepsTitle' })}
            className={css.flowImage}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default GoLiveSteps;
